<template>
  <div class="contents10">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <div class="setting-img">
        <img class="setting" src="static/img/icon_setting.png" />
      </div>
      <p class="text1">
        새로운 정비 문화를 열어가는<br />
        자동차 애프터마켓 플랫폼 <span>카랑</span>입니다.<br />
      </p>
      <div class="btn-wrap" v-if="!isMobile">
        <div class="btn" @click="gotoPage('https://www.carsuri.co.kr/contact?tab=runoil')">
          <img :src="icon_car" />
          <span>카수리 가맹점 문의</span>
          <div class="arrow">
            <img src="static/img/btn_arrow_b.png" />
          </div>
        </div>
        <div class="btn" @click="gotoPage('https://www.carsuri.co.kr/contact?tab=corporate-vehicle')">
          <img :src="icon_carBlue" />
          <span>법인 차량 관리 문의</span>
          <div class="arrow">
            <img src="static/img/btn_arrow_b.png" />
          </div>
        </div>
      </div>
      <div class="btn-wrap" v-if="!isMobile">
        <div class="btn" @click="gotoPage('https://www.carsuri.co.kr/contact?tab=exterior-repair')">
          <img :src="icon_repair" />
          <span>외장수리 업체 등록 문의</span>
          <div class="arrow">
            <img src="static/img/btn_arrow_b.png" />
          </div>
        </div>
        <div class="btn" @click="gotoPage('https://www.carsuri.co.kr/contact?tab=advertisement')">
          <img :src="icon_mail" />
          <span>광고 / 제휴 문의</span>
          <div class="arrow">
            <img src="static/img/btn_arrow_b.png" />
          </div>
        </div>
      </div>
      <div class="btn-wrap" v-if="isMobile">
        <div class="btn" @click="gotoPage('https://www.carsuri.co.kr/contact?tab=runoil')">
          <img :src="icon_car" />
          <span>카수리 가맹점 문의</span>
          <div class="arrow">
            <img src="static/img/btn_arrow_b.png" />
          </div>
        </div>
        <div class="btn" @click="gotoPage('https://www.carsuri.co.kr/contact?tab=corporate-vehicle')">
          <img :src="icon_carBlue" />
          <span>법인 차량 관리 문의</span>
          <div class="arrow">
            <img src="static/img/btn_arrow_b.png" />
          </div>
        </div>
        <div class="btn" @click="gotoPage('https://www.carsuri.co.kr/contact?tab=exterior-repair')">
          <img :src="icon_repair" />
          <span>외장수리 업체 등록 문의</span>
          <div class="arrow">
            <img src="static/img/btn_arrow_b.png" />
          </div>
        </div>
        <div class="btn" @click="gotoPage('https://www.carsuri.co.kr/contact?tab=advertisement')">
          <img :src="icon_mail" />
          <span>광고 / 제휴 문의</span>
          <div class="arrow">
            <img src="static/img/btn_arrow_b.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: 'static/img/main-content/contents10.png',
      icon_car: 'static/img/icon_car.png',
      icon_carBlue: 'static/img/icon_car_blue.png',
      icon_repair: 'static/img/icon_repair.png',
      icon_mail: 'static/img/icon_mail.png',
      icon_arrow: 'static/img/btn_arrow_b.png',
      isMobile: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/contents10.png'
        this.icon_car = 'static/img/icon_car.png'
        this.icon_carBlue = 'static/img/icon_car_blue.png'
        this.icon_repair = 'static/img/icon_repair.png'
        this.icon_mail = 'static/img/icon_mail.png'
        this.icon_arrow = 'static/img/btn_arrow_b.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/contents10.png'
        this.icon_car = 'static/img/mobile/main-content/icon_car.png'
        this.icon_carBlue = 'static/img/mobile/main-content/icon_car_blue.png'
        this.icon_repair = 'static/img/mobile/main-content/icon_repair.png'
        this.icon_mail = 'static/img/mobile/main-content/icon_mail.png'
        this.icon_arrow = 'static/img/mobile/main-content/btn_arrow_b.png'
        this.isMobile = true
      }
    },
    gotoPage(path) {
      window.open(path)
    }
  }
}
</script>

<style scoped>
.contents10 {
  width: 100%;
  position: relative;
}
.contents10 .bg {
  width: 100%;
  height: auto;
  display: block;
}
/* pc */
@media (max-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 26px;
    line-height: 43px;
    color: #ffffff;
    margin-bottom: 5%;
  }
  .text1 span {
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    line-height: 43px;
    color: #ffffff;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
  .setting-img .setting {
    width: 35px;
    height: auto;
  }
  .btn img {
    width: 25px;
    height: auto;
  }
  .btn span {
    margin-left: 5%;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    color: #ffffff;
  }
}
@media (min-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 2.05vw;
    line-height: 3.4vw;
    color: #ffffff;
    margin-bottom: 5%;
  }
  .text1 span {
    font-style: normal;
    font-weight: bold;
    font-size: 2.05vw;
    line-height: 3.4vw;
    color: #ffffff;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
  .setting-img .setting {
    width: 3vw;
    height: auto;
  }
  .btn img {
    width: 2vw;
    height: auto;
  }
  .btn span {
    margin-left: 5%;
    font-style: normal;
    font-weight: normal;
    font-size: 1.4vw;
    color: #ffffff;
  }
}
@media (min-width: 641px) {
  .contents10 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 10% 15% 0 15%;
  }
  .setting-img {
    margin-bottom: 2%;
  }
  .btn-wrap {
    display: flex;
    width: 100%;
    height: 20%;
  }
  .btn {
    width: 47%;
    border: 2px solid #ffffff;
    box-sizing: border-box;
    border-radius: 6px;
    height: 70%;
    margin-right: 2%;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 5%;
    cursor: pointer;
  }
  .arrow {
    position: absolute;
    right: 5%;
    top: 30%;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents10 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    text-align: center;
  }
  .setting-img .setting {
    margin-top: 20%;
    margin-bottom: 2%;
    width: 10vw;
    height: auto;
  }
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 5vw;
    line-height: 10vw;
    color: #ffffff;
    margin-bottom: 12.5%;
  }
  .text1 span {
    font-style: normal;
    font-weight: bold;
    font-size: 5vw;
    line-height: 10vw;
    color: #ffffff;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
  .setting-img {
    margin-bottom: 2%;
  }
  .btn-wrap {
    display: inline-block;
    width: 100%;
    height: 22.5%;
    padding: 0 5%;
  }
  .btn {
    margin: 5% 0;
    width: 100%;
    border: 2px solid #ffffff;
    box-sizing: border-box;
    border-radius: 6px;
    height: 45%;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 5%;
    cursor: pointer;
  }
  .btn img {
    width: 6vw;
    height: auto;
  }
  .btn span {
    margin-left: 5%;

    font-style: normal;
    font-weight: normal;
    font-size: 5vw;
    color: #ffffff;
  }
  .arrow {
    position: absolute;
    right: 5%;
    top: 29%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents10.vue